import createCachedSelector from 're-reselect';

import { normalize } from 'utils/stringFunctions';
import sortContacts from './sortContacts';
import sortMainAttributes from './sortMainAttributes';

const getCategories = ({ myself: { categories } }) => categories;
const getQualities = ({ myself: { qualities } }) => qualities;
const getFilterString = (state, { filterString = '' }) => filterString;

const getName = (state, props) => props.name;
const cacheKey = (state, props) => `${getName(state, props)}`;

const inputFuncs = [getCategories, getQualities, getFilterString, getName];

const outputFunc = (categories, qualities, filterString, name) => {
  const category = categories.find(c => c.name === name);
  // const categoryQualities = category.qualities.map(id => qualities.find(q => q.id === id));
  const categoryQualities = category.qualities.map(qualityIdToQuality({ qualities }));
  // Filter by name and level, then sort by main attribute and Contacts special-case stuff
  return [...categoryQualities]
    .filter(q => normalize(q.name).indexOf(normalize(filterString)) >= 0)
    .filter(isNonZero)
    .sort(sortMainAttributes)
    .sort(sortContacts);
};

export function qualityIdToQuality({ qualities }) {
  return id => qualities.find(q => q.id === id);
}

export function isNonZero(q) {
  return q.effectiveLevel > 0;
}

export default createCachedSelector(inputFuncs, outputFunc)(cacheKey);